import React, { useMemo, useState } from 'react';
import { CheckCircle2, ShieldCheck } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';

import CredentialSetupModal from 'features/conversation/credentials/CredentialSetupModal';

export default function ExternalCredentialSetupPage() {
  const navigate = useNavigate();
  const { requestId = '' } = useParams();
  const [completed, setCompleted] = useState(null);
  const requestAction = useMemo(
    () => (requestId && !completed ? { requestId } : null),
    [requestId, completed]
  );

  return (
    <main className="flex min-h-screen items-center justify-center bg-neutral-950 p-6 text-white">
      <section className="w-full max-w-lg rounded-xl border border-white/10 bg-neutral-900 p-7 shadow-2xl">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-emerald-400/10 text-emerald-300">
            {completed ? <CheckCircle2 size={23} /> : <ShieldCheck size={23} />}
          </span>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-emerald-300">
              LineSide secure connection
            </p>
            <h1 className="mt-1 text-xl font-semibold">
              {completed ? 'Credentials stored securely' : 'Integration credential setup'}
            </h1>
          </div>
        </div>
        <p className="mt-5 text-sm leading-6 text-neutral-300">
          {completed
            ? 'Return to your personal agent and ask it to check credential status, test the connection, and continue authoring.'
            : 'Credential values are sent directly to the tenant-aware broker. They are never added to your personal-agent conversation, MCP tool arguments, or ordinary LineSide rows.'}
        </p>
        {completed ? (
          <button
            type="button"
            onClick={() => navigate('/app/integrations', { replace: true })}
            className="mt-6 h-10 rounded-md bg-white px-4 text-sm font-semibold text-neutral-950 hover:bg-neutral-100"
          >
            Open integrations
          </button>
        ) : null}
      </section>
      <CredentialSetupModal
        requestAction={requestAction}
        onClose={() => navigate('/app/integrations', { replace: true })}
        onCompleted={setCompleted}
      />
    </main>
  );
}
